import { render, staticRenderFns } from "./GestionProductos.vue?vue&type=template&id=8b404848"
import script from "./GestionProductos.vue?vue&type=script&lang=js"
export * from "./GestionProductos.vue?vue&type=script&lang=js"
import style0 from "./GestionProductos.vue?vue&type=style&index=0&id=8b404848&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports